var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"org-chart-glossary"},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"org-chart-glossary-item"},[_c('span',{style:({ backgroundColor: item.color })}),_vm._v(_vm._s(item.label))])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-591717ba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/job-evaluation/components/supplies/organization-chart/OrgChartGlossary.vue
// module id = 2759
// module chunks = 10